import React from 'react';

export default () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="black" />
        <circle cx="10" cy="7" r="3" fill="white" />
        <ellipse cx="10" cy="14" rx="6" ry="3" fill="white" />
    </svg>
)